import React, { useState, useEffect } from 'react';

const soles = (n) => `S/. ${Number(n || 0).toFixed(2)}`;

const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconCartPlus = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 13v4M10 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 20 20" fill="none" width="15" height="15" style={{flexShrink:0}}><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.25)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

export default function ModalRelacionado({ producto, enCarrito, onAgregar, onVerCarrito, onCerrar }) {
  const [activa, setActiva] = useState(0);

  /* Cerrar con Escape y bloquear scroll del fondo */
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onCerrar(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onCerrar]);

  if (!producto) return null;

  const p       = producto;
  const galeria = p.imagenes?.length ? p.imagenes : (p.imagen_url ? [p.imagen_url] : []);
  const conDto  = p.descuento_pct > 0;

  const ficha = [
    p.formato && ['Formato', p.formato],
    p.paginas && ['Páginas', p.paginas],
    p.nivel   && ['Nivel',   p.nivel],
    ['Entrega', 'Descarga inmediata'],
  ].filter(Boolean);

  return (
    <div
      onClick={onCerrar}
      style={{
        position:'fixed', inset:0, zIndex:9998,
        background:'rgba(17,22,20,.6)', backdropFilter:'blur(3px)',
        display:'flex', alignItems:'center', justifyContent:'center', padding:'1.2rem',
      }}>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background:'#fff', borderRadius:20, width:'100%', maxWidth:680,
          maxHeight:'90vh', overflowY:'auto',
          boxShadow:'0 20px 60px rgba(0,0,0,.3)', position:'relative',
        }}>

        {/* Cerrar */}
        <button onClick={onCerrar} aria-label="Cerrar"
          style={{
            position:'absolute', top:14, right:14, zIndex:2,
            width:34, height:34, borderRadius:'50%', border:'none',
            background:'rgba(255,255,255,.92)', color:'#111614',
            display:'flex', alignItems:'center', justifyContent:'center',
            cursor:'pointer', boxShadow:'0 2px 8px rgba(0,0,0,.15)',
          }}>
          <IconClose/>
        </button>

        <div style={{ padding:'1.6rem 1.6rem 1.4rem' }}>

          {/* Galería */}
          {galeria.length > 0 && (
            <div style={{ marginBottom:'1.2rem' }}>
              <div style={{ width:'100%', aspectRatio:'4/3', borderRadius:14, overflow:'hidden', background:'#f3f8f5', position:'relative' }}>
                <img src={galeria[activa]} alt={p.titulo}
                  style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
                {galeria.length > 1 && (
                  <>
                    <button onClick={() => setActiva(a => (a - 1 + galeria.length) % galeria.length)}
                      style={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', background:'rgba(0,0,0,.45)', border:'none', color:'#fff', borderRadius:'50%', width:34, height:34, cursor:'pointer', fontSize:'1.1rem' }}>‹</button>
                    <button onClick={() => setActiva(a => (a + 1) % galeria.length)}
                      style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'rgba(0,0,0,.45)', border:'none', color:'#fff', borderRadius:'50%', width:34, height:34, cursor:'pointer', fontSize:'1.1rem' }}>›</button>
                    <span style={{ position:'absolute', bottom:10, right:12, background:'rgba(0,0,0,.5)', color:'#fff', fontSize:'.7rem', fontWeight:700, padding:'.18rem .55rem', borderRadius:100 }}>
                      {activa + 1}/{galeria.length}
                    </span>
                  </>
                )}
              </div>

              {galeria.length > 1 && (
                <div style={{ display:'flex', gap:'.4rem', overflowX:'auto', marginTop:'.55rem' }}>
                  {galeria.map((url, i) => (
                    <button key={i} onClick={() => setActiva(i)}
                      style={{ width:56, height:56, borderRadius:8, overflow:'hidden', flexShrink:0, padding:0, cursor:'pointer', background:'none', border: i === activa ? '2px solid #14736C' : '2px solid transparent' }}>
                      <img src={url} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }}/>
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Cabecera */}
          <span style={{ fontSize:'.7rem', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:'#4db88a' }}>
            {p.tipo === 'curso' ? 'Curso' : 'Material'} · {p.categoria}
          </span>
          <h2 style={{ margin:'.4rem 0 .8rem', fontSize:'1.25rem', fontWeight:700, color:'#111614', lineHeight:1.35 }}>
            {p.titulo}
          </h2>

          {p.descripcion && (
            <p style={{ margin:'0 0 .7rem', fontSize:'.92rem', color:'#5a6a63', lineHeight:1.7 }}>{p.descripcion}</p>
          )}
          {p.descripcion_larga && (
            <p style={{ margin:'0 0 1rem', fontSize:'.88rem', color:'#5a6a63', lineHeight:1.75, whiteSpace:'pre-line' }}>
              {p.descripcion_larga}
            </p>
          )}

          {/* Ficha */}
          {ficha.length > 0 && (
            <div style={{ display:'flex', flexWrap:'wrap', gap:'.5rem', marginBottom:'1.1rem' }}>
              {ficha.map(([k, v]) => (
                <span key={k} style={{ display:'flex', alignItems:'center', gap:'.35rem', background:'#f3f8f5', borderRadius:100, padding:'.35rem .8rem', fontSize:'.78rem', color:'#5a6a63' }}>
                  <IconCheck/> <strong style={{ color:'#111614', fontWeight:600 }}>{v}</strong>
                </span>
              ))}
            </div>
          )}

          {/* Precio + acción */}
          <div style={{
            display:'flex', alignItems:'center', justifyContent:'space-between',
            gap:'1rem', flexWrap:'wrap',
            background: conDto ? '#edfaf4' : '#f3f8f5',
            border: `1.5px solid ${conDto ? 'rgba(139,202,175,.45)' : 'rgba(139,202,175,.25)'}`,
            borderRadius:14, padding:'1rem 1.2rem',
          }}>
            <div>
              {conDto ? (
                <>
                  <s style={{ fontSize:'.85rem', color:'#9ca3af' }}>{soles(p.precio)}</s>
                  <div style={{ display:'flex', alignItems:'baseline', gap:'.5rem' }}>
                    <strong style={{ fontSize:'1.4rem', color:'#14736C' }}>{soles(p.precio_paquete)}</strong>
                    <span style={{ fontSize:'.72rem', fontWeight:700, color:'#14736C' }}>
                      −{Math.round(p.descuento_pct)}% en paquete
                    </span>
                  </div>
                  <p style={{ margin:'.25rem 0 0', fontSize:'.74rem', color:'#5a6a63' }}>
                    Este precio aplica llevándolo junto con el curso.
                  </p>
                </>
              ) : (
                <>
                  <strong style={{ fontSize:'1.4rem', color:'#111614' }}>{soles(p.precio)}</strong>
                  {p.precio_antes && (
                    <s style={{ fontSize:'.85rem', color:'#9ca3af', marginLeft:'.5rem' }}>{soles(p.precio_antes)}</s>
                  )}
                </>
              )}
            </div>

            {enCarrito ? (
              <button onClick={onVerCarrito}
                style={{ background:'#4db88a', color:'#fff', border:'none', borderRadius:100, padding:'.7rem 1.4rem', fontFamily:'inherit', fontWeight:700, fontSize:'.85rem', cursor:'pointer', whiteSpace:'nowrap' }}>
                Ver carrito
              </button>
            ) : (
              <button onClick={() => { onAgregar(p); onCerrar(); }}
                style={{ display:'flex', alignItems:'center', gap:'.4rem', background:'#032D29', color:'#8BCAAF', border:'none', borderRadius:100, padding:'.7rem 1.4rem', fontFamily:'inherit', fontWeight:700, fontSize:'.85rem', cursor:'pointer', whiteSpace:'nowrap' }}>
                <IconCartPlus/> Agregar {conDto ? 'suelto' : 'al carrito'}
              </button>
            )}
          </div>

          {conDto && !enCarrito && (
            <p style={{ margin:'.7rem 0 0', fontSize:'.76rem', color:'#9ca3af', textAlign:'center' }}>
              Agregarlo suelto cuesta {soles(p.precio)}. Para el precio con descuento, márcalo y usa “Agregar paquete”.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}